import { useQuery } from "@tanstack/react-query";
import api from "../../http";
import { RequestProduct } from "../../../products/types";

interface PaginatedResponse {
    docs: RequestProduct[];
    totalDocs: number;
    limit: number;
    totalPages: number;
    page: number;
    pagingCounter: number;
    hasPrevPage: boolean;
    hasNextPage: boolean;
    prevPage: number | null;
    nextPage: number | null;
}

interface UseGetRequestProductsParams {
    page?: number;
    limit?: number;
    refetchInterval?: number | false;
    enabled?: boolean;
    search?: string;
    status?: 'PENDING' | 'APPROVED' | 'REJECTED';
}

export const useGetRequestProducts = ({ page = 1, limit = 100, refetchInterval = false, enabled = true, search, status }: UseGetRequestProductsParams = {}) => {
    const query = useQuery({
        queryKey: ['request-products', 'findAll', page, limit, search, status],
        refetchInterval,
        enabled,
        placeholderData: (previousData, previousQuery) =>
            previousQuery?.queryKey[5] === status ? previousData : undefined,
        queryFn: async (): Promise<PaginatedResponse> => {
            const { data } = await api.get<PaginatedResponse>('/request-products/findAll', {
                params: { page, limit, search, status }
            });
            return data;
        },
    });

    return {
        ...query,
        data: query.data?.docs ?? [],
        pagination: query.data ? {
            totalDocs: query.data.totalDocs,
            totalPages: query.data.totalPages,
            page: query.data.page,
            hasPrevPage: query.data.hasPrevPage,
            hasNextPage: query.data.hasNextPage,
            prevPage: query.data.prevPage,
            nextPage: query.data.nextPage,
        } : null,
    };
};
